import React from "react";
import { Stack, Typography } from "@mui/material";
import DateInput from "../input/DateInput";

interface IFilterTimeFormTo {
  label?: string;
  timeFrom?: Date;
  timeTo?: Date;
  onChange?: (dates: {
    timeFrom: Date | undefined;
    timeTo: Date | undefined;
  }) => void;
}

function FilterTimeFormTo({
  label,
  timeFrom,
  timeTo,
  onChange,
}: IFilterTimeFormTo) {
  return (
    <Stack gap={1}>
      {label && <Typography sx={{ fontWeight: 500 }}>{label}</Typography>}
      <Stack
        gap={1}
        sx={{
          border: "1px dashed",
          borderColor: "divider",
          p: 1,
          borderRadius: "10px",
        }}
      >
        <DateInput
          direction="column"
          label="Từ ngày"
          value={timeFrom}
          onChange={(value) => onChange?.({ timeFrom: value, timeTo })}
        />
        <DateInput
          direction="column"
          label="Đến ngày"
          value={timeTo}
          onChange={(value) => onChange?.({ timeTo: value, timeFrom })}
        />
      </Stack>
    </Stack>
  );
}

export default FilterTimeFormTo;
